"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const webViewer_1 = __importDefault(require("../../components/webViewer/webViewer"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const Webview = ({ route }) => {
    const { title, url } = route.params;
    return (react_1.default.createElement(navContainer_1.default, { isLoading: false, childrenTitle: title },
        react_1.default.createElement(webViewer_1.default, { docSrc: url })));
};
exports.default = Webview;
